"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canSaveExemptUsers = exports.getUserExemptionOptions = exports.getCurrentExemptUserIds = exports.getStagedExemptUserIds = exports.canSaveSamlSettings = exports.isSamlRequired = exports.doSamlSettingsExist = exports.getStagedSamlServiceValidationError = exports.getStagedSamlServiceValidationErrorRaw = exports.getStagedSamlEntityValidationError = exports.getStagedSamlCertificateValidationError = exports.getStagedSamlService = exports.getStagedSamlEntity = exports.getStagedSamlCertificate = exports.getStagedSamlRequirement = exports.getStagedSamlIdp = exports.getSamlSettings = void 0;

var _Url = _interopRequireDefault(require("PatternValidationJS/patterns/Url"));

var _reselect = require("reselect");

var _I18n = _interopRequireDefault(require("I18n"));

var _constants = require("./constants");

var _selectors = require("../Users/selectors");

// Matches strings with :{PORT} or :{PORT}/
var UrlPortRegex = /:([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])($|\/)/;

var getFromNullableMap = function getFromNullableMap(nullableMap, key) {
  if (nullableMap) {
    return nullableMap.get(key);
  }

  return null;
};

var isNullOrEmpty = function isNullOrEmpty(str) {
  return str === null || str.trim() === '';
};

var getSingleSignOn = function getSingleSignOn(state) {
  return state.modules['account-defaults'].singleSignOn;
};

var getSingleSignOnSettings = (0, _reselect.createSelector)([getSingleSignOn], function (singleSignOn) {
  return singleSignOn.get('settings');
});
var getSingleSignOnStagedSettings = (0, _reselect.createSelector)([getSingleSignOn], function (singleSignOn) {
  return singleSignOn.get('staged');
});
var getSamlSettings = (0, _reselect.createSelector)([getSingleSignOnSettings], function (singleSignOn) {
  return singleSignOn.get('samlSettings');
});
exports.getSamlSettings = getSamlSettings;
var getConfirmedSettings = (0, _reselect.createSelector)([getSamlSettings], function (samlSettings) {
  return getFromNullableMap(samlSettings, _constants.CONFIRMED_SAML_IDP);
});
var getSamlCertificate = (0, _reselect.createSelector)([getConfirmedSettings], function (samlSettings) {
  return getFromNullableMap(samlSettings, _constants.CERTIFICATE);
});
var getSamlEntity = (0, _reselect.createSelector)([getConfirmedSettings], function (samlSettings) {
  return getFromNullableMap(samlSettings, _constants.ENTITY);
});
var getSamlService = (0, _reselect.createSelector)([getConfirmedSettings], function (samlSettings) {
  return getFromNullableMap(samlSettings, _constants.SERVICE);
});
var getRequirement = (0, _reselect.createSelector)([getSamlSettings], function (samlSettings) {
  return getFromNullableMap(samlSettings, _constants.REQUIREMENT);
});
var getStagedSamlSettings = (0, _reselect.createSelector)([getSingleSignOnStagedSettings], function (stagedSingleSignOn) {
  return stagedSingleSignOn.get('samlSettings');
});
var getStagedSamlIdp = (0, _reselect.createSelector)([getStagedSamlSettings], function (stagedSamlSettings) {
  return stagedSamlSettings.get('idp');
});
exports.getStagedSamlIdp = getStagedSamlIdp;
var getStagedSamlRequirement = (0, _reselect.createSelector)([getStagedSamlSettings], function (stagedSamlSettings) {
  return stagedSamlSettings.get('requirement');
});
exports.getStagedSamlRequirement = getStagedSamlRequirement;
var getStagedSamlCertificate = (0, _reselect.createSelector)([getStagedSamlIdp], function (stagedSamlSettings) {
  return getFromNullableMap(stagedSamlSettings, _constants.CERTIFICATE);
});
exports.getStagedSamlCertificate = getStagedSamlCertificate;
var getStagedSamlEntity = (0, _reselect.createSelector)([getStagedSamlIdp], function (stagedSamlSettings) {
  return getFromNullableMap(stagedSamlSettings, _constants.ENTITY);
});
exports.getStagedSamlEntity = getStagedSamlEntity;
var getStagedSamlService = (0, _reselect.createSelector)([getStagedSamlIdp], function (stagedSamlSettings) {
  return getFromNullableMap(stagedSamlSettings, _constants.SERVICE);
});
exports.getStagedSamlService = getStagedSamlService;

var changed = function changed(selectorA, selectorB) {
  return (0, _reselect.createSelector)([selectorA, selectorB], function (a, b) {
    return a !== b;
  });
};

var validateIfChanged = function validateIfChanged(changedSelector, validationSelector) {
  return (0, _reselect.createSelector)([changedSelector, validationSelector], function (isChanged, validationResult) {
    if (!isChanged) {
      return null;
    }

    return validationResult;
  });
};

var getStagedSamlCertificateValidationErrorRaw = (0, _reselect.createSelector)([getStagedSamlCertificate], function (stagedCertificate) {
  if (isNullOrEmpty(stagedCertificate)) {
    return 'NULL_OR_EMPTY';
  }

  return null;
});
var isSamlCertificateChanged = changed(getSamlCertificate, getStagedSamlCertificate);
var getStagedSamlCertificateValidationError = validateIfChanged(isSamlCertificateChanged, getStagedSamlCertificateValidationErrorRaw);
exports.getStagedSamlCertificateValidationError = getStagedSamlCertificateValidationError;
var getStagedSamlEntityValidationErrorRaw = (0, _reselect.createSelector)([getStagedSamlEntity], function (stagedEntity) {
  if (isNullOrEmpty(stagedEntity)) {
    return 'NULL_OR_EMPTY';
  }

  if (stagedEntity.toLowerCase().startsWith('urn:')) {
    return null;
  }

  if (!_Url.default.test(stagedEntity.replace(UrlPortRegex, '/'))) {
    return 'INVALID_URL_OR_URN';
  }

  return null;
});
var isSamlEntityChanged = changed(getSamlEntity, getStagedSamlEntity);
var getStagedSamlEntityValidationError = validateIfChanged(isSamlEntityChanged, getStagedSamlEntityValidationErrorRaw);
exports.getStagedSamlEntityValidationError = getStagedSamlEntityValidationError;
var getStagedSamlServiceValidationErrorRaw = (0, _reselect.createSelector)([getStagedSamlService], function (stagedService) {
  if (isNullOrEmpty(stagedService)) {
    return 'NULL_OR_EMPTY';
  }

  if (!_Url.default.test(stagedService.replace(UrlPortRegex, '/'))) {
    return 'INVALID_URL';
  }

  return null;
});
exports.getStagedSamlServiceValidationErrorRaw = getStagedSamlServiceValidationErrorRaw;
var isSamlServiceChanged = changed(getSamlService, getStagedSamlService);
var getStagedSamlServiceValidationError = validateIfChanged(isSamlServiceChanged, getStagedSamlServiceValidationErrorRaw);
exports.getStagedSamlServiceValidationError = getStagedSamlServiceValidationError;
var doSamlSettingsExist = (0, _reselect.createSelector)([getSingleSignOnSettings, getSamlCertificate, getSamlEntity, getSamlService], function (singleSignOn, certificate, entity, service) {
  return singleSignOn.get(_constants.GET_SSO_ENABLED) || !isNullOrEmpty(certificate) && !isNullOrEmpty(entity) && !isNullOrEmpty(service);
});
exports.doSamlSettingsExist = doSamlSettingsExist;
var isSamlRequired = (0, _reselect.createSelector)([getRequirement], function (requirement) {
  return requirement === _constants.REQUIRED;
});
exports.isSamlRequired = isSamlRequired;
var canSaveSamlSettings = (0, _reselect.createSelector)([getStagedSamlCertificateValidationErrorRaw, getStagedSamlEntityValidationErrorRaw, getStagedSamlServiceValidationErrorRaw, isSamlCertificateChanged, isSamlEntityChanged, isSamlServiceChanged], function (certificateError, entityError, serviceError, certificateChanged, entityChanged, serviceChanged) {
  return certificateError === null && entityError === null && serviceError === null && (certificateChanged || entityChanged || serviceChanged);
});
exports.canSaveSamlSettings = canSaveSamlSettings;
var getStagedExemptUserIds = (0, _reselect.createSelector)([getStagedSamlSettings], function (stagedSamlSettings) {
  return stagedSamlSettings.get(_constants.EXEMPT_USER_IDS);
});
exports.getStagedExemptUserIds = getStagedExemptUserIds;
var getCurrentExemptions = (0, _reselect.createSelector)([getSamlSettings], function (currentSettings) {
  return currentSettings.get(_constants.USER_EXEMPTIONS);
});
var getCurrentExemptUserIds = (0, _reselect.createSelector)([getCurrentExemptions], function (currentExemptions) {
  return currentExemptions.map(function (exemption) {
    return exemption.get('userId');
  });
});
exports.getCurrentExemptUserIds = getCurrentExemptUserIds;
var getUserExemptionOptions = (0, _reselect.createSelector)([_selectors.getUsers], function (users) {
  return users.map(function (user) {
    return {
      text: _I18n.default.formatName({
        firstName: user.get('firstName'),
        lastName: user.get('lastName')
      }) + " (" + user.get('email') + ")",
      value: user.get('id')
    };
  }).toArray();
});
exports.getUserExemptionOptions = getUserExemptionOptions;
var canSaveExemptUsers = (0, _reselect.createSelector)([getStagedExemptUserIds, getCurrentExemptUserIds], function (stagedExemptUserIds, currentExemptUserIds) {
  return !currentExemptUserIds.equals(stagedExemptUserIds);
});
exports.canSaveExemptUsers = canSaveExemptUsers;